module.exports = __webpack_public_path__ + "img/zaplanirovat.f61d196f.svg";